import { useEffect, useState } from "react";
import { PanelBottom, PanelTop } from "lucide-react";

import { RichEditor } from "components/RichEditor/RichEditor";
import { Button } from "components/ui/Button";
import { PageHeader } from "components/ui/PageHeader";
import { TabSwitcher } from "components/ui/TabSwitcher";
import { useHeaderFooter } from "features/practice/hooks/useHeaderFooter";
import { useUpdateHeaderFooter } from "features/practice/hooks/useUpdateHeaderFooter";

import styles from "./HeaderFooterPage.module.css";

const TAB_OPTIONS = [
  { value: "header", label: "Header", icon: <PanelTop size={16} /> },
  { value: "footer", label: "Footer", icon: <PanelBottom size={16} /> },
];

export const HeaderFooterPage = () => {
  const { data: headerFooter, isLoading } = useHeaderFooter();
  const { mutate: updateHeaderFooter, isPending: isSaving } =
    useUpdateHeaderFooter();

  const [activeTab, setActiveTab] = useState("header");
  const [headerContent, setHeaderContent] = useState("");
  const [footerContent, setFooterContent] = useState("");

  useEffect(() => {
    if (headerFooter) {
      setHeaderContent(headerFooter.header || "");
      setFooterContent(headerFooter.footer || "");
    }
  }, [headerFooter]);

  const handleSave = () => {
    const updatedContent =
      activeTab === "header"
        ? { header: headerContent }
        : { footer: footerContent };

    updateHeaderFooter({ ...headerFooter, ...updatedContent });
  };

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <span>Loading...</span>
      </div>
    );
  }

  return (
    <div className={styles.content}>
      <PageHeader title="Headers & Footers" />

      <TabSwitcher
        options={TAB_OPTIONS}
        value={activeTab}
        onChange={setActiveTab}
        fullWidth
      />

      <div className={styles.form}>
        {activeTab === "header" && (
          <RichEditor editorValue={headerContent} onChange={setHeaderContent} />
        )}

        {activeTab === "footer" && (
          <RichEditor editorValue={footerContent} onChange={setFooterContent} />
        )}

        <div className={styles.formActions}>
          <Button onClick={handleSave} disabled={isSaving}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </div>
      </div>
    </div>
  );
};
